module.exports = __webpack_public_path__ + "media/images/svg/tiktok-5e53a224cb87ae53aafc9fbd10958003.svg";